<template>
  <div
    class="input-wrap ba-mb-4 ba-pb-3 ba-w-full text-center"
    :class="{'input-wrap--focus': focus, 'input-wrap--active': value}"
  >
    <input
      :id="id"
      :type="type"
      :name="name"
      :required="required"
      :disabled="disabled"
      :value="value"
      :icon="icon"
      class="ba-rounded-xl ba-mb-1 ba-py-2 ba-w-full ba-font-base ba-border-b ba-border-solid"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @input="onInput"
    />
    <label
      :class="{'input-wrap__label--active' : focus || value !== '' }"
      class="input-wrap__label u-transition ba-absolute ba-left-0 ba-leading-none ba-opacity-75"
      :for="id"
    >{{ label }}</label>
    <i class="ba-absolute ba-right-0 ba-text-md" :class="icon"></i>
    <div
      v-if="errorMessageText"
      class="error ba-absolute ba-left-0 ba-bottom-0 ba-text-xs ba-leading-none"
    >{{errorMessageText}}</div>
  </div>
</template>

<script>
export default {
  name: "vis-form-input",
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String,
      default: ""
    },
    customRequired: {
      type: Boolean,
      default: false
    },
    customRequiredMessage: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      focus: false,
      isValid: true
    };
  },
  computed: {
    errorMessageText() {
      if (this.errorMessage) {
        return this.errorMessage;
      }

      if (!this.isValid) {
        if (this.customRequired) {
          return this.customRequiredMessage;
        }
      }

      return "";
    }
  },
  methods: {
    onInput(event) {
      const { value } = event.target;
      this.validate(value);
      this.$emit("input", value);
    },
    onFocusIn() {
      this.focus = true;
    },
    onFocusOut() {
      this.focus = false;
      this.validate(this.value);
    },
    validate(value) {
      if (this.customRequired) {
        this.isValid = !!value;
        return;
      }

      this.isValid = true;
    }
  }
};
</script>
